import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { GiCoffeeCup } from "react-icons/gi";

const Contact = () => {
  return (
    <Container>
      <section id="contact" className="pt-5 px-5">
        <h3 className="mb-5">CONTACT</h3>
        <Container>
          <Row>
            <Col lg={6}>
              <h2>
                Let's talk <GiCoffeeCup className="mb-2" /> <br /> Tell me about
                your project
              </h2>
              <p>Let's create something different together</p>
            </Col>
            <Col lg={6} className="d-flex flex-column">
              <input
                type="text"
                placeholder="Full name"
                className="mb-3 px-3 py-2"
                disabled
              />
              <input
                type="text"
                placeholder="Email address"
                className="mb-3 px-3 py-2"
                disabled
              />
              <input
                type="text"
                placeholder="Subject"
                className="mb-3 px-3 py-2"
                disabled
              />
              <textarea
                placeholder="Tell me more about your project"
                className="mb-3 px-3 py-2"
                rows="4"
                disabled
              />
              <div className="d-flex justify-content-center">
                <button
                  onClick={() =>
                    alert(
                      "Unfortunately, messages can't be sent right now, you can email me instead .. Thank you for your interest"
                    )
                  }
                >
                  SUBMIT
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Container>
  );
};

export default Contact;
